import { Link, useLocation } from "react-router-dom";
import { getPageLocale, getPageMarket, localizedPath } from "@/utils/pageLocale";
import { useHydratedSearch } from "@/hooks/useHydratedSearch";

const LanguageSwitch = ({ path }: { path: "/openai-partner" | "/ai-call" }) => {
  const { pathname } = useLocation();
  const search = useHydratedSearch();
  const locale = getPageLocale(pathname);
  const market = getPageMarket(locale, search);

  return (
    <div
      role="group"
      aria-label={locale === "pt-BR" ? "Idioma da página" : "Page language"}
      className="flex shrink-0 items-center gap-1 text-sm"
    >
      {(["en", "pt-BR"] as const).map((language, index) => {
        const params = new URLSearchParams(search);
        params.set("language", language);
        if (language === "pt-BR" || market === "BR") params.set("market", "BR");
        return (
          <span key={language} className="flex items-center gap-1">
            {index > 0 && <span aria-hidden="true" className="text-muted-foreground">|</span>}
            <Link
              to={`${localizedPath(path, language)}?${params}`}
              lang={language}
              hrefLang={language}
              aria-current={locale === language ? "page" : undefined}
              className={`inline-flex min-h-11 items-center rounded px-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400 ${locale === language ? "font-semibold text-orange-400" : "text-inherit hover:underline"}`}
            >
              {language === "pt-BR" ? "Português" : "English"}
            </Link>
          </span>
        );
      })}
    </div>
  );
};

export default LanguageSwitch;
